import { Alignment, Collection } from "@mcleod/core";
import { AnchorProps } from "../../Anchor";

export enum Placement {
    TOP = "top",
    TOP_START = "top-start",
    TOP_END = "top-end",
    BOTTOM = "bottom",
    BOTTOM_START = "bottom-start",
    BOTTOM_END = "bottom-end",
    LEFT = "left",
    LEFT_START = "left-start",
    LEFT_END = "left-end",
    RIGHT = "right",
    RIGHT_START = "right-start",
    RIGHT_END = "right-end"
}
const BASE_PLACEMENT_MAP: Record<Alignment, Placement> = {
    [Alignment.TOP]: Placement.TOP,
    [Alignment.BOTTOM]: Placement.BOTTOM,
    [Alignment.LEFT]: Placement.LEFT,
    [Alignment.RIGHT]: Placement.RIGHT,
    [Alignment.CENTER]: Placement.BOTTOM
};

export const PLACEMENT_FALLBACKS: Collection<Placement[]> = {
    [Placement.TOP]: [Placement.BOTTOM, Placement.RIGHT, Placement.LEFT],
    [Placement.RIGHT]: [Placement.BOTTOM, Placement.TOP, Placement.LEFT],
    [Placement.BOTTOM]: [Placement.RIGHT, Placement.TOP, Placement.LEFT],
    [Placement.LEFT]: [Placement.BOTTOM, Placement.TOP, Placement.RIGHT]
}

export const POSITION_AND_ALIGNMENTS: Record<Placement, { position: Alignment, align: Alignment }> = {
    [Placement.TOP]: { position: Alignment.TOP, align: Alignment.CENTER },
    [Placement.TOP_START]: { position: Alignment.TOP, align: Alignment.LEFT },
    [Placement.TOP_END]: { position: Alignment.TOP, align: Alignment.RIGHT },
    [Placement.BOTTOM]: { position: Alignment.BOTTOM, align: Alignment.CENTER },
    [Placement.BOTTOM_START]: { position: Alignment.BOTTOM, align: Alignment.LEFT },
    [Placement.BOTTOM_END]: { position: Alignment.BOTTOM, align: Alignment.RIGHT },
    [Placement.LEFT]: { position: Alignment.LEFT, align: Alignment.CENTER },
    [Placement.LEFT_START]: { position: Alignment.LEFT, align: Alignment.TOP },
    [Placement.LEFT_END]: { position: Alignment.LEFT, align: Alignment.BOTTOM },
    [Placement.RIGHT]: { position: Alignment.RIGHT, align: Alignment.CENTER },
    [Placement.RIGHT_START]: { position: Alignment.RIGHT, align: Alignment.TOP },
    [Placement.RIGHT_END]: { position: Alignment.RIGHT, align: Alignment.BOTTOM },
};

export class FloatingUI {

    public static getPlacementFromAlignment(alignment: Alignment): Placement {
        return BASE_PLACEMENT_MAP[alignment] ?? Placement.BOTTOM;
    }

    public static getPlacementfromAnchor(props: AnchorProps): Placement {
        // Placement is a combination of position and align
        const placement: Placement = FloatingUI.getPlacementFromAlignment(props.position);
        if (props.align == null)
            return placement;
        switch (placement) {
            case Placement.TOP:
                if (props.align === Alignment.LEFT)
                    return Placement.TOP_START;
                if (props.align === Alignment.RIGHT)
                    return Placement.TOP_END;
                break;
            case Placement.BOTTOM:
                if (props.align === Alignment.LEFT)
                    return Placement.BOTTOM_START;
                if (props.align === Alignment.RIGHT)
                    return Placement.BOTTOM_END;
                break;
            case Placement.LEFT:
                if (props.align === Alignment.TOP)
                    return Placement.LEFT_START;
                if (props.align === Alignment.BOTTOM)
                    return Placement.LEFT_END;
                break;
            case Placement.RIGHT:
                if (props.align === Alignment.TOP)
                    return Placement.RIGHT_START;
                if (props.align === Alignment.BOTTOM)
                    return Placement.RIGHT_END;
                break;
        }
        return placement;
    }

    public static getPlacementFallbacks(placement: Placement): Placement[] {
        const placementWithoutAlignment = FloatingUI.getPlacementWithoutAlignment(placement);
        return PLACEMENT_FALLBACKS[placementWithoutAlignment];
    }

    public static getPlacementWithoutAlignment(placement: Placement): Placement {
        if (placement == null)
            return Placement.BOTTOM;
       return placement.split("-")[0] as Placement;
    }
}
